import { render } from "./CompetitorRequests.vue?vue&type=template&id=25f4b542&scoped=true&ts=true"
import script from "./CompetitorRequests.vue?vue&type=script&lang=ts"
export * from "./CompetitorRequests.vue?vue&type=script&lang=ts"

import "./CompetitorRequests.vue?vue&type=style&index=0&id=25f4b542&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f4b542"]])

export default __exports__